import { render, staticRenderFns } from "./plan-deptList.vue?vue&type=template&id=fa38cee6&"
import script from "./plan-deptList.vue?vue&type=script&lang=js&"
export * from "./plan-deptList.vue?vue&type=script&lang=js&"
import style0 from "./plan-deptList.vue?vue&type=style&index=0&id=fa38cee6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports